import config from 'netxcore@netx/core-auth/config';

Object.assign(config, {
	POST_LOGIN_HASH_NAME: 'cleanPostLoginHash',
});

export default config;
